import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api/axios";

export default function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then((res) => setOrder(res.data));
  }, [id]);

  if (!order) return <div className="max-w-2xl mx-auto px-4 py-20 text-white/50">Loading...</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display font-semibold text-2xl mb-2">Order confirmed</h1>
      <p className="text-white/50 font-mono text-sm mb-8">#{order._id}</p>
      <div className="space-y-3 mb-8">
        {order.items.map((item, i) => (
          <div key={i} className="flex justify-between text-sm bg-surface border border-white/10 rounded-lg p-4">
            <span>{item.name} × {item.qty}</span>
            <span className="font-mono">₹{(item.price * item.qty).toFixed(2)}</span>
          </div>
        ))}
      </div>
      <div className="flex justify-between font-mono text-lg border-t border-white/10 pt-4">
        <span>Total</span><span>₹{order.totalPrice.toFixed(2)}</span>
      </div>
      <p className="text-white/50 text-sm mt-4">Status: <span className="text-mint font-mono">{order.status}</span></p>
    </div>
  );
}
